function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import styled from "styled-components";
import { Button } from "./Buttons";
import sanitizeHtml from "sanitize-html";
const StyledContent = styled.div`
  padding-bottom: 2rem;
`;

class AlertWarning extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      const {
        message,
        onConfirm,
        buttonSize = 'sm',
        confirmText,
        ...restProps
      } = this.props;
      const sanitizedHtml = sanitizeHtml(message, {
        allowedTags: ['b', 'i', 'em', 'strong', 'a', 's', 'u', 'ol', 'li', 'ul', 'span', 'br'],
        allowedAttributes: {
          a: ['href', 'target'],
          span: ['class']
        }
      });
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledContent, null, /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: sanitizedHtml
        }
      })), /*#__PURE__*/React.createElement(Button, _extends({
        onClick: onConfirm,
        color: this.props.color || 'info',
        size: buttonSize,
        cypress: 'alertWarningConfirm'
      }, restProps), confirmText || 'Yes'));
    });
  }

}

export default AlertWarning;